import { PhTextAlignLeft } from 'phosphor-vue/dist/phosphor-vue.esm'

import { type BuilderBlockModule } from '@/lib/builder'

import i18n from '@/plugins/i18n'

import {
  type CampaignResource,
  type LoyaltyExplainerSection,
  type LoyaltyExplainerSectionCreate,
  type LoyaltyExplainerSectionUpdate,
} from '../../types'
import { emailBlockMethods } from '../common/methods'

import { createLoyaltyExplainerData } from './methods/createLoyaltyExplainerData'
import LoyaltyExplainerPreview from './preview/LoyaltyExplainerPreview.vue'

export const LoyaltyExplainerBlockModule: BuilderBlockModule<
  LoyaltyExplainerSection,
  LoyaltyExplainerSectionCreate,
  LoyaltyExplainerSectionUpdate,
  CampaignResource
> = {
  canAdd: false,
  canDelete: false,
  canReorderDown: false,
  canReorderUp: false,
  createData: createLoyaltyExplainerData,
  meta: [
    {
      icon: PhTextAlignLeft,
      key: 'loyalty-explainer',
      label: i18n.t('email-builder.blocks.loyalty'),
    },
  ],
  methods: emailBlockMethods,
  preview: LoyaltyExplainerPreview,
}
